/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A datetime string with format `Y-m-d H:i:s`, e.g. `2018-05-23 13:43:32`. Also accepts PostgreSQL format with microseconds. */
  DateTime: { input: any; output: any; }
  /** A datetime and timezone string in ISO 8601 format `Y-m-dTH:i:sP`, e.g. `2020-04-20T13:53:12+02:00`. */
  DateTimeTz: { input: any; output: any; }
  /** An integer ID that must be a valid numeric value. Rejects values like 'undefined'. */
  IntID: { input: any; output: any; }
};

/** Will migrate to shared enums if needed */
export enum AcceptanceProbabilityValue {
  Good = 'GOOD',
  Great = 'GREAT',
  Poor = 'POOR'
}

export type AccessType = {
  __typename?: 'AccessType';
  coming_soon: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  guest_summary?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Media>;
  intercom: IntercomSetting;
  min_membership_action?: Maybe<MinMembershipAction>;
  min_membership_level?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  price_summary?: Maybe<Scalars['String']['output']>;
  product_button_icon?: Maybe<Scalars['String']['output']>;
  product_group_icon?: Maybe<Scalars['String']['output']>;
  product_group_label?: Maybe<Scalars['String']['output']>;
  product_grouping?: Maybe<AccessTypeProductGrouping>;
  product_layout?: Maybe<AccessTypeLayout>;
  product_page_heading?: Maybe<Scalars['String']['output']>;
  product_review_label?: Maybe<Scalars['String']['output']>;
  required_idv_levels?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  sort_order: Scalars['Int']['output'];
};

export enum AccessTypeLayout {
  Detailed = 'DETAILED',
  Simple = 'SIMPLE'
}

export enum AccessTypeProductGrouping {
  ByEvent = 'BY_EVENT',
  ByEventGroup = 'BY_EVENT_GROUP'
}

export type AdditionalTip = {
  __typename?: 'AdditionalTip';
  amount?: Maybe<Scalars['Float']['output']>;
  amount__currency?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  value__currency?: Maybe<Scalars['String']['output']>;
};

export type AllowSpecialRequest = {
  __typename?: 'AllowSpecialRequest';
  allowed?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['String']['output']>;
};

export type AlternativePickupContact = {
  __typename?: 'AlternativePickupContact';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type AppTranslation = {
  __typename?: 'AppTranslation';
  buttons__back_to_preview_app?: Maybe<Scalars['String']['output']>;
  buttons__go_to_settings_cta?: Maybe<Scalars['String']['output']>;
  buttons__have_referral_code?: Maybe<Scalars['String']['output']>;
  buttons__instant_apply?: Maybe<Scalars['String']['output']>;
  buttons__instant_apply_sub?: Maybe<Scalars['String']['output']>;
  buttons__logout?: Maybe<Scalars['String']['output']>;
  buttons__window_shopping_cta?: Maybe<Scalars['String']['output']>;
  cancellation_reasons__LACK_OF_INVENTORY?: Maybe<Scalars['String']['output']>;
  cancellation_reasons__OTHER?: Maybe<Scalars['String']['output']>;
  cancellation_reasons__PRICE_TOO_HIGH?: Maybe<Scalars['String']['output']>;
  cancellation_reasons__UNINTENTIONAL_SUBSCRIBE?: Maybe<Scalars['String']['output']>;
  cancellation_reasons__WANTED_TO_BROWSE?: Maybe<Scalars['String']['output']>;
  modals__ach_crypto_incentives__description?: Maybe<Scalars['String']['output']>;
  modals__ach_crypto_incentives__title?: Maybe<Scalars['String']['output']>;
  screens__contact_access_error_education__body?: Maybe<Scalars['String']['output']>;
  screens__contact_access_error_education__title?: Maybe<Scalars['String']['output']>;
  screens__contact_sync_education__body?: Maybe<Scalars['String']['output']>;
  screens__contact_sync_education__title?: Maybe<Scalars['String']['output']>;
  screens__contact_sync_not_verified__body?: Maybe<Scalars['String']['output']>;
  screens__contact_sync_not_verified__title?: Maybe<Scalars['String']['output']>;
  screens__contact_sync_verified__body?: Maybe<Scalars['String']['output']>;
  screens__contact_sync_verified__title?: Maybe<Scalars['String']['output']>;
  screens__membership_application_intro_instant__body?: Maybe<Scalars['String']['output']>;
  screens__membership_application_intro_instant__title?: Maybe<Scalars['String']['output']>;
  screens__membership_application_intro_manual__body?: Maybe<Scalars['String']['output']>;
  screens__membership_application_intro_manual__title?: Maybe<Scalars['String']['output']>;
  screens__referral_code_entry__title?: Maybe<Scalars['String']['output']>;
};

export type ApplicableWalletFunds = {
  __typename?: 'ApplicableWalletFunds';
  credits?: Maybe<Scalars['Int']['output']>;
  credits__currency?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  points__currency?: Maybe<Scalars['String']['output']>;
};

export type Area = {
  __typename?: 'Area';
  active: Scalars['Boolean']['output'];
  /**
   * Active children ordered alphabetically.
   * Used for public browsing accordion UI.
   */
  activeChildren: Array<Maybe<Area>>;
  children: Array<Maybe<Area>>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  map_search_enabled: Scalars['Boolean']['output'];
  map_search_zoom_level?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  restaurants?: Maybe<Array<Restaurant>>;
  searchable_name: Scalars['String']['output'];
  stripe_public_key?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of Area items. */
export type AreaPaginator = {
  __typename?: 'AreaPaginator';
  /** A list of Area items. */
  data: Array<Area>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Article = {
  __typename?: 'Article';
  body_markdown?: Maybe<Scalars['String']['output']>;
  collab_byline?: Maybe<Scalars['String']['output']>;
  dorsia_byline?: Maybe<Scalars['String']['output']>;
  dorsia_exclusive: Scalars['Boolean']['output'];
  headerMedia: Media;
  id: Scalars['ID']['output'];
  media: Array<Media>;
  pivot?: Maybe<RestaurantArticle>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  publisher?: Maybe<Publisher>;
  short_blurb?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Availability = {
  __typename?: 'Availability';
  actual_price?: Maybe<Scalars['Int']['output']>;
  can_join_waitlist?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  datetime_label?: Maybe<Scalars['String']['output']>;
  datetime_utc?: Maybe<Scalars['DateTimeTz']['output']>;
  display_price?: Maybe<Scalars['Int']['output']>;
  drop_expires_at?: Maybe<Scalars['DateTimeTz']['output']>;
  drop_status?: Maybe<Scalars['String']['output']>;
  incentive_level?: Maybe<Scalars['Int']['output']>;
  is_fully_booked?: Maybe<Scalars['Boolean']['output']>;
  is_waitlist_gated?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  min_membership_level: Scalars['Int']['output'];
  my_waitlist_entry_id?: Maybe<Scalars['ID']['output']>;
  options: Array<Maybe<AvailabilitySeatingOption>>;
  price: Scalars['Int']['output'];
  price__currency: Scalars['String']['output'];
  price_range_indicator?: Maybe<Scalars['String']['output']>;
  requires_upgrade?: Maybe<Scalars['Boolean']['output']>;
  schedule_block_id?: Maybe<Scalars['ID']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
  waitlist_drop_days_before?: Maybe<Scalars['Int']['output']>;
  waitlist_tier_requirement?: Maybe<Scalars['Int']['output']>;
};

export type AvailabilityNotification = {
  __typename?: 'AvailabilityNotification';
  label?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<Array<Maybe<AvailabilityNotificationData>>>;
};

export type AvailabilityNotificationData = {
  __typename?: 'AvailabilityNotificationData';
  end_date?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_always?: Maybe<Scalars['Boolean']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
};

export type AvailabilitySeatingOption = {
  __typename?: 'AvailabilitySeatingOption';
  actual_price?: Maybe<Scalars['Int']['output']>;
  can_join_waitlist?: Maybe<Scalars['Boolean']['output']>;
  datetime_local__formatted: DateTimeFormat;
  datetime_utc: Scalars['DateTimeTz']['output'];
  display_price?: Maybe<Scalars['Int']['output']>;
  drop_expires_at?: Maybe<Scalars['DateTimeTz']['output']>;
  drop_status?: Maybe<Scalars['String']['output']>;
  dynamic_pricing_meta?: Maybe<DynamicPricingMeta>;
  has_joined_waitlist?: Maybe<Scalars['Boolean']['output']>;
  incentive_level?: Maybe<Scalars['Int']['output']>;
  is_booked?: Maybe<Scalars['Boolean']['output']>;
  is_waitlist_gated?: Maybe<Scalars['Boolean']['output']>;
  is_waitlist_joinable?: Maybe<Scalars['Boolean']['output']>;
  min_membership_level: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  price__currency?: Maybe<Scalars['String']['output']>;
  price_range_indicator?: Maybe<Scalars['String']['output']>;
  requires_upgrade?: Maybe<Scalars['Boolean']['output']>;
  schedule_block_id?: Maybe<Scalars['ID']['output']>;
  seating_id: Scalars['Int']['output'];
  seats: Scalars['Int']['output'];
  table_minimum__currency?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user_waitlist_entry_id?: Maybe<Scalars['ID']['output']>;
  waitlist_count?: Maybe<Scalars['Int']['output']>;
  waitlist_drop_days_before?: Maybe<Scalars['Int']['output']>;
  waitlist_tier_requirement?: Maybe<Scalars['Int']['output']>;
};

export type AvailableReward = {
  __typename?: 'AvailableReward';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: RewardType;
  value: Scalars['String']['output'];
};

export type Award = {
  __typename?: 'Award';
  background_color?: Maybe<Scalars['String']['output']>;
  default_extra?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  logo_image_url?: Maybe<Scalars['String']['output']>;
  pivot?: Maybe<RestaurantAward>;
  text_color?: Maybe<Scalars['String']['output']>;
};

export enum BookingLinkStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Expired = 'EXPIRED',
  Sent = 'SENT'
}

export enum CancelationReason {
  LackOfInventory = 'LACK_OF_INVENTORY',
  Other = 'OTHER',
  PriceTooHigh = 'PRICE_TOO_HIGH',
  UnintentionalSubscribe = 'UNINTENTIONAL_SUBSCRIBE',
  WantedToBrowse = 'WANTED_TO_BROWSE'
}

export enum ComingSoonOrigin {
  Hero = 'HERO',
  List = 'LIST',
  Promo = 'PROMO'
}

export type Concierge = {
  __typename?: 'Concierge';
  email?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  teams: Array<Maybe<Team>>;
};

export type ConciergeBooking = {
  __typename?: 'ConciergeBooking';
  concierge?: Maybe<Concierge>;
  concierge_id: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  real_phone_formatted?: Maybe<Scalars['String']['output']>;
  reservation?: Maybe<Reservation>;
  reservation_id: Scalars['Int']['output'];
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['Int']['output']>;
};

export type ContactDetail = {
  __typename?: 'ContactDetail';
  version: Scalars['Int']['output'];
};

export type Content = {
  __typename?: 'Content';
  /**  Markdown content  */
  content: Scalars['String']['output'];
  /**  Unique ID or Slug  */
  uuid: Scalars['String']['output'];
};

export type ContentCollection = {
  __typename?: 'ContentCollection';
  availability_end?: Maybe<Scalars['String']['output']>;
  availability_start?: Maybe<Scalars['String']['output']>;
  badge_type?: Maybe<Scalars['String']['output']>;
  cover?: Maybe<Cover>;
  cover_content?: Maybe<Scalars['String']['output']>;
  display_style: Scalars['String']['output'];
  dynamic: Scalars['Boolean']['output'];
  has_more?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  intelligent_randomization?: Maybe<Scalars['Boolean']['output']>;
  items?: Maybe<Array<ContentCollectionItem>>;
  should_homepage_animate?: Maybe<Scalars['Boolean']['output']>;
  sub_title?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: ContentCollectionType;
};

export enum ContentCollectionArea {
  HomeScreen = 'HOME_SCREEN',
  HomeScreenUnderContent = 'HOME_SCREEN_UNDER_CONTENT',
  RestaurantFeed = 'RESTAURANT_FEED',
  Search = 'SEARCH'
}

export type ContentCollectionItem = {
  __typename?: 'ContentCollectionItem';
  allow_subscription_to_coming_soon?: Maybe<Scalars['Boolean']['output']>;
  badge_title?: Maybe<Scalars['String']['output']>;
  badge_title_alternative?: Maybe<Scalars['String']['output']>;
  booking_cta_restaurant_id?: Maybe<Scalars['ID']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  coming_soon_restaurant?: Maybe<Restaurant>;
  cta_text?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hero_media?: Maybe<Media>;
  id: Scalars['ID']['output'];
  item?: Maybe<ContentCollectionItemItem>;
  left_title?: Maybe<Scalars['String']['output']>;
  right_title?: Maybe<Scalars['String']['output']>;
  subscribed_to_coming_soon?: Maybe<Scalars['Boolean']['output']>;
  theme?: Maybe<ContentCollectionItemTheme>;
  title?: Maybe<Scalars['String']['output']>;
  title_badge_media?: Maybe<Media>;
  title_badge_text?: Maybe<Scalars['String']['output']>;
  title_badge_type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ContentCollectionItemItem = Article | Cover | ExternalArticle | HeroMedia | Restaurant;

export enum ContentCollectionItemTheme {
  Dark = 'DARK',
  Light = 'LIGHT'
}

export enum ContentCollectionType {
  Article = 'ARTICLE',
  MarketingSquare = 'MARKETING_SQUARE',
  Restaurant = 'RESTAURANT'
}

export type CountryCode = {
  __typename?: 'CountryCode';
  alpha2: Scalars['String']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Cover = {
  __typename?: 'Cover';
  collection_id?: Maybe<Scalars['String']['output']>;
  collection_image_url?: Maybe<Scalars['String']['output']>;
  collection_view_cta_action?: Maybe<Scalars['String']['output']>;
  collection_view_cta_label?: Maybe<Scalars['String']['output']>;
  cover_title?: Maybe<Scalars['String']['output']>;
  hero_image_url?: Maybe<Scalars['String']['output']>;
  homescreen_cta_action?: Maybe<Scalars['String']['output']>;
  homescreen_cta_label?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type Cuisine = {
  __typename?: 'Cuisine';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  primary?: Maybe<Scalars['Boolean']['output']>;
  restaurants?: Maybe<Array<Maybe<Restaurant>>>;
};

export enum Currency {
  Aed = 'AED',
  Eur = 'EUR',
  Gbp = 'GBP',
  Mxn = 'MXN',
  Pnt = 'PNT',
  Usd = 'USD'
}

export type CustomRequestExpirationOption = {
  __typename?: 'CustomRequestExpirationOption';
  default: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  hours: Scalars['Int']['output'];
};

export type CustomRequestPriceOption = {
  __typename?: 'CustomRequestPriceOption';
  acceptance_chance: AcceptanceProbabilityValue;
  acceptance_label: Scalars['String']['output'];
  default: Scalars['Boolean']['output'];
  price: Scalars['Int']['output'];
};

export type CustomRequestSettings = {
  __typename?: 'CustomRequestSettings';
  expiration_options: Array<Maybe<CustomRequestExpirationOption>>;
  price_options: Array<Maybe<CustomRequestPriceOption>>;
  response_time: ResponseTimeDetails;
  table_options: Array<Maybe<TableType>>;
};

export type DateFormats = {
  __typename?: 'DateFormats';
  date_dow_long?: Maybe<Scalars['String']['output']>;
  date_dow_short?: Maybe<Scalars['String']['output']>;
  date_long?: Maybe<Scalars['String']['output']>;
  date_short?: Maybe<Scalars['String']['output']>;
  date_slashes?: Maybe<Scalars['String']['output']>;
  date_slashes_short?: Maybe<Scalars['String']['output']>;
  iso8601?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type DateTimeFormat = {
  __typename?: 'DateTimeFormat';
  date: Scalars['String']['output'];
  date_dow_long: Scalars['String']['output'];
  date_dow_short: Scalars['String']['output'];
  date_long: Scalars['String']['output'];
  date_short: Scalars['String']['output'];
  date_slashes: Scalars['String']['output'];
  date_slashes_short: Scalars['String']['output'];
  iso8601: Scalars['String']['output'];
  time: Scalars['String']['output'];
  year: Scalars['String']['output'];
};

export type Descriptor = {
  __typename?: 'Descriptor';
  name: Scalars['String']['output'];
};

export type Divider = {
  __typename?: 'Divider';
  version: Scalars['Int']['output'];
};

export type Document = {
  __typename?: 'Document';
  description?: Maybe<Scalars['String']['output']>;
  latestVersion: DocumentVersion;
  title: Scalars['String']['output'];
};

export type DocumentVersion = {
  __typename?: 'DocumentVersion';
  document: Document;
  id: Scalars['ID']['output'];
  markdown: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DynamicPricingMeta = {
  __typename?: 'DynamicPricingMeta';
  auto_dynamic_pricing_ceiling?: Maybe<Scalars['Int']['output']>;
  auto_dynamic_pricing_enabled?: Maybe<Scalars['Boolean']['output']>;
  auto_dynamic_pricing_floor?: Maybe<Scalars['Int']['output']>;
  auto_dynamic_pricing_price?: Maybe<Scalars['Boolean']['output']>;
  base_price?: Maybe<Scalars['Int']['output']>;
  bookable_elsewhere_ceiling_price?: Maybe<Scalars['Int']['output']>;
  day_of_week_percent_modifier?: Maybe<Scalars['Int']['output']>;
  days_out_percent_modifier?: Maybe<Scalars['Int']['output']>;
  hours_out_percent_modifier?: Maybe<Scalars['Int']['output']>;
  specific_day_percent_modifier?: Maybe<Scalars['Int']['output']>;
  times_of_day_percent_modifier?: Maybe<Scalars['Int']['output']>;
};

export type ErrorResponse = {
  __typename?: 'ErrorResponse';
  message: Scalars['String']['output'];
};

export type Event = {
  __typename?: 'Event';
  accessTypeImageOverrides: Array<EventImageOverride>;
  allow_distribute_all_tickets: Scalars['Boolean']['output'];
  allow_ticket_resharing: Scalars['Boolean']['output'];
  capacity: Scalars['Int']['output'];
  cardImage?: Maybe<Media>;
  date: Scalars['String']['output'];
  datetime_end_utc?: Maybe<Scalars['DateTimeTz']['output']>;
  datetime_local__formatted?: Maybe<DateFormats>;
  group?: Maybe<EventGroup>;
  id: Scalars['ID']['output'];
  inventory: Array<Maybe<EventInventory>>;
  l1_button_label?: Maybe<Scalars['String']['output']>;
  l1_page_header?: Maybe<Scalars['String']['output']>;
  min_membership_level?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  production?: Maybe<Restaurant>;
  sold_out: Scalars['Boolean']['output'];
  ticketTypeImageOverrides: Array<EventImageOverride>;
  time: Scalars['String']['output'];
  venueImage?: Maybe<Media>;
};

export type EventGroup = {
  __typename?: 'EventGroup';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Media>;
  name: Scalars['String']['output'];
};

export type EventImageOverride = {
  __typename?: 'EventImageOverride';
  id: Scalars['ID']['output'];
  image?: Maybe<Media>;
  overrideable_id: Scalars['ID']['output'];
};

export type EventInventory = {
  __typename?: 'EventInventory';
  allowedPaymentTypes: Array<Maybe<PaymentType>>;
  /**
   * Bundled inventory items included when purchasing this inventory.
   * Used for multi-day bundles (e.g., Full Weekend passes).
   */
  bundledInventory: Array<Maybe<EventInventory>>;
  event_id: Scalars['String']['output'];
  /**
   * Whether this inventory is currently in an exclusive access window.
   * When true, only notified members can purchase until the window expires.
   */
  exclusive_window_active: Scalars['Boolean']['output'];
  /**
   * When the exclusive window ends (ISO 8601 datetime).
   * Null if no exclusive window is active.
   */
  exclusive_window_ends_at?: Maybe<Scalars['DateTimeTz']['output']>;
  guests: Scalars['Int']['output'];
  /**
   * Whether this inventory has tiered pricing enabled.
   * When true, use the 'tiers' field to get pricing tiers.
   */
  has_tiered_pricing: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Media>;
  item: InventoryItem;
  /**
   * The lowest available price from visible tiers (in cents).
   * Used for "From $X per guest" display.
   * Null if no tiered pricing.
   */
  lowest_tier_price?: Maybe<Scalars['Int']['output']>;
  /**
   * The lowest available price formatted with currency symbol.
   * Used for "From $X per guest" display.
   */
  lowest_tier_price__currency?: Maybe<Scalars['String']['output']>;
  maximum_purchasable: Scalars['Int']['output'];
  original_price: Scalars['Float']['output'];
  original_price__currency?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  price__currency?: Maybe<Scalars['String']['output']>;
  product_badge?: Maybe<Scalars['String']['output']>;
  product_button_label: Scalars['String']['output'];
  product_details_description_1: Scalars['String']['output'];
  product_details_description_2: Scalars['String']['output'];
  product_details_icon_1?: Maybe<Scalars['String']['output']>;
  product_details_icon_2?: Maybe<Scalars['String']['output']>;
  sold_out: Scalars['Boolean']['output'];
  /**
   * Number of pricing tiers for this inventory.
   * Returns 0 if has_tiered_pricing is false.
   */
  tier_count: Scalars['Int']['output'];
  /**
   * Pricing tiers for this inventory item.
   * Only populated when has_tiered_pricing is true.
   * Tiers are ordered by tier_order (1, 2, 3...).
   * Only returns visible tiers (activated or display_mode='disabled').
   */
  tiers: Array<Maybe<EventInventoryTier>>;
};

/**
 * A pricing tier within an EventInventory.
 * Tiers are child rows that define different price points with automatic activation.
 */
export type EventInventoryTier = {
  __typename?: 'EventInventoryTier';
  /**
   * How this tier is displayed before activation.
   * 'hidden' = not rendered until activated
   * 'disabled' = visible but greyed out
   */
  display_mode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /**
   * Whether this tier has been activated and is available for purchase.
   * First tier (tier_order=1) is always activated.
   */
  is_activated: Scalars['Boolean']['output'];
  /** Whether this tier is sold out (quantity_sold >= quantity) */
  is_sold_out: Scalars['Boolean']['output'];
  /** Whether this tier is visible to members (activated or display_mode='disabled') */
  is_visible: Scalars['Boolean']['output'];
  /** Name of the previous tier (for "Unlocks when X sells out" messaging) */
  previous_tier_name?: Maybe<Scalars['String']['output']>;
  /** Price for this tier (in cents) */
  price: Scalars['Int']['output'];
  /** Price formatted with currency symbol */
  price__currency?: Maybe<Scalars['String']['output']>;
  /** Total quantity available for this tier */
  quantity: Scalars['Int']['output'];
  /** Number of units sold from this tier */
  quantity_sold: Scalars['Int']['output'];
  /** Tier status for display: 'active', 'sold_out', or 'coming_soon' */
  status: Scalars['String']['output'];
  /** Display name for this tier (e.g., "Early Bird", "Standard", "Tier 3") */
  tier_name: Scalars['String']['output'];
  /** Order in the tier sequence (1, 2, 3...). First tier is always active. */
  tier_order: Scalars['Int']['output'];
};

export type ExternalArticle = {
  __typename?: 'ExternalArticle';
  hero_image_url?: Maybe<Scalars['String']['output']>;
  hero_media?: Maybe<Media>;
  published_at?: Maybe<Scalars['DateTime']['output']>;
  publisher: Publisher;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Faq = {
  __typename?: 'FAQ';
  information: Array<QuestionAnswer>;
  title?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

/** Available features. */
export enum Features {
  AccountCreditWithPoints = 'ACCOUNT_CREDIT_WITH_POINTS',
  AccountPageEarnRewards = 'ACCOUNT_PAGE_EARN_REWARDS',
  AchIncentives = 'ACH_INCENTIVES',
  AllowAchForEventTickets = 'ALLOW_ACH_FOR_EVENT_TICKETS',
  AllowAchForMembershipSubscriptions = 'ALLOW_ACH_FOR_MEMBERSHIP_SUBSCRIPTIONS',
  AllowAchForRestaurantBookings = 'ALLOW_ACH_FOR_RESTAURANT_BOOKINGS',
  AllowMemberAppStoreReview = 'ALLOW_MEMBER_APP_STORE_REVIEW',
  AllowTicketScreenshot = 'ALLOW_TICKET_SCREENSHOT',
  AmbassadorNominationSkipContactSync = 'AMBASSADOR_NOMINATION_SKIP_CONTACT_SYNC',
  AndroidNitroImage = 'ANDROID_NITRO_IMAGE',
  ApplePay = 'APPLE_PAY',
  AutoPayWaitlist = 'AUTO_PAY_WAITLIST',
  BookingsTabV2 = 'BOOKINGS_TAB_V2',
  CalendarSync = 'CALENDAR_SYNC',
  CancellationIssuesFunCoupons = 'CANCELLATION_ISSUES_FUN_COUPONS',
  ChooseMembershipVersion2 = 'CHOOSE_MEMBERSHIP_VERSION2',
  ChoosePlanPageV3 = 'CHOOSE_PLAN_PAGE_V3',
  ContactSyncA = 'CONTACT_SYNC_A',
  ContactSyncB = 'CONTACT_SYNC_B',
  ContactSyncC = 'CONTACT_SYNC_C',
  ContactSyncExperiment = 'CONTACT_SYNC_EXPERIMENT',
  CryptoIncentives = 'CRYPTO_INCENTIVES',
  CultureCalendar = 'CULTURE_CALENDAR',
  CustomRequestExpirationTimeSelection = 'CUSTOM_REQUEST_EXPIRATION_TIME_SELECTION',
  CustomRequestSlider = 'CUSTOM_REQUEST_SLIDER',
  DefaultDayInFuture = 'DEFAULT_DAY_IN_FUTURE',
  DeveloperSettings = 'DEVELOPER_SETTINGS',
  DorsiaWrapped = 'DORSIA_WRAPPED',
  EmbeddedPaymentBooking = 'EMBEDDED_PAYMENT_BOOKING',
  EmbeddedPaymentBookingLink = 'EMBEDDED_PAYMENT_BOOKING_LINK',
  EmbeddedPaymentCustomRequest = 'EMBEDDED_PAYMENT_CUSTOM_REQUEST',
  EmbeddedPaymentCustomRequestConfirm = 'EMBEDDED_PAYMENT_CUSTOM_REQUEST_CONFIRM',
  EmbeddedPaymentEventBooking = 'EMBEDDED_PAYMENT_EVENT_BOOKING',
  EmbeddedPaymentMembershipCharge = 'EMBEDDED_PAYMENT_MEMBERSHIP_CHARGE',
  EmbeddedPaymentPaymentManager = 'EMBEDDED_PAYMENT_PAYMENT_MANAGER',
  EmbeddedPaymentProductsOrder = 'EMBEDDED_PAYMENT_PRODUCTS_ORDER',
  EmbeddedPaymentSplitPay = 'EMBEDDED_PAYMENT_SPLIT_PAY',
  EnableAddingCryptoFundsFromCheckout = 'ENABLE_ADDING_CRYPTO_FUNDS_FROM_CHECKOUT',
  EnableContactSync = 'ENABLE_CONTACT_SYNC',
  EnableContentCollectionHeroNotifyMeComingSoonForRestaurants = 'ENABLE_CONTENT_COLLECTION_HERO_NOTIFY_ME_COMING_SOON_FOR_RESTAURANTS',
  EnableIncompleteMembershipModalFlow = 'ENABLE_INCOMPLETE_MEMBERSHIP_MODAL_FLOW',
  EnableListingNotifyMeComingSoonForRestaurants = 'ENABLE_LISTING_NOTIFY_ME_COMING_SOON_FOR_RESTAURANTS',
  EnableNotificationCenter = 'ENABLE_NOTIFICATION_CENTER',
  EnableNotificationCenterPhase4 = 'ENABLE_NOTIFICATION_CENTER_PHASE4',
  EnableNotificationCenterPreferences = 'ENABLE_NOTIFICATION_CENTER_PREFERENCES',
  EnableNotificationCenterPush = 'ENABLE_NOTIFICATION_CENTER_PUSH',
  EnablePastDueModalFlow = 'ENABLE_PAST_DUE_MODAL_FLOW',
  EnablePromoNotifyMeComingSoonForRestaurants = 'ENABLE_PROMO_NOTIFY_ME_COMING_SOON_FOR_RESTAURANTS',
  EnableReservationOverlapModal = 'ENABLE_RESERVATION_OVERLAP_MODAL',
  EnableSpecialRequests = 'ENABLE_SPECIAL_REQUESTS',
  EnforceContactSync = 'ENFORCE_CONTACT_SYNC',
  EnsureContactSyncForShortenedProfileUsers = 'ENSURE_CONTACT_SYNC_FOR_SHORTENED_PROFILE_USERS',
  EventBookingBottomSheet = 'EVENT_BOOKING_BOTTOM_SHEET',
  ExecutiveBookingToggle = 'EXECUTIVE_BOOKING_TOGGLE',
  ExecutiveOrganizationFilter = 'EXECUTIVE_ORGANIZATION_FILTER',
  ExecNomination = 'EXEC_NOMINATION',
  ExpiredMembershipPreview = 'EXPIRED_MEMBERSHIP_PREVIEW',
  FunCouponsAndRefundCredits = 'FUN_COUPONS_AND_REFUND_CREDITS',
  FunCouponEducation = 'FUN_COUPON_EDUCATION',
  FunCouponHistory = 'FUN_COUPON_HISTORY',
  FunCouponHistoryBalance = 'FUN_COUPON_HISTORY_BALANCE',
  GeofencingArrivalDetection = 'GEOFENCING_ARRIVAL_DETECTION',
  GooglePay = 'GOOGLE_PAY',
  HomeNotificationCenterAlwaysVisible = 'HOME_NOTIFICATION_CENTER_ALWAYS_VISIBLE',
  HomePageContentCollections = 'HOME_PAGE_CONTENT_COLLECTIONS',
  IncludeFullyBookedAvailability = 'INCLUDE_FULLY_BOOKED_AVAILABILITY',
  InventoryDrops = 'INVENTORY_DROPS',
  InventoryDropsV2 = 'INVENTORY_DROPS_V2',
  InventoryWaitlist = 'INVENTORY_WAITLIST',
  MembershipGate = 'MEMBERSHIP_GATE',
  MembershipSavingsBanner = 'MEMBERSHIP_SAVINGS_BANNER',
  MemberSalesPageABTest = 'MEMBER_SALES_PAGE_A_B_TEST',
  MoonPay = 'MOON_PAY',
  MoonPayOverrideMinimumAmount = 'MOON_PAY_OVERRIDE_MINIMUM_AMOUNT',
  MultipleDaysOfAvailabilityOnHomeScreen = 'MULTIPLE_DAYS_OF_AVAILABILITY_ON_HOME_SCREEN',
  MultipleDayMultipleRestaurantAvailability = 'MULTIPLE_DAY_MULTIPLE_RESTAURANT_AVAILABILITY',
  NominateViaCode = 'NOMINATE_VIA_CODE',
  NominationsV2 = 'NOMINATIONS_V2',
  NominationRequest = 'NOMINATION_REQUEST',
  NominationTokenClaimsEnabled = 'NOMINATION_TOKEN_CLAIMS_ENABLED',
  NotifyMe = 'NOTIFY_ME',
  OptionalUseOfCredits = 'OPTIONAL_USE_OF_CREDITS',
  PaidMembership = 'PAID_MEMBERSHIP',
  Plaid = 'PLAID',
  PlaidIdentityVerification = 'PLAID_IDENTITY_VERIFICATION',
  PremiumMembershipUpgrades = 'PREMIUM_MEMBERSHIP_UPGRADES',
  PremiumWeekNY = 'PREMIUM_WEEK_N_Y',
  ProfilePhoto = 'PROFILE_PHOTO',
  RefundSourceMatching = 'REFUND_SOURCE_MATCHING',
  ReservationCalendarSync = 'RESERVATION_CALENDAR_SYNC',
  RestaurantMapSearch = 'RESTAURANT_MAP_SEARCH',
  RotatingPassBarcode = 'ROTATING_PASS_BARCODE',
  ShowDorsiaValuePropsBanner = 'SHOW_DORSIA_VALUE_PROPS_BANNER',
  ShowDynamicPricingLoadingIndicator = 'SHOW_DYNAMIC_PRICING_LOADING_INDICATOR',
  ShowNominationRequests = 'SHOW_NOMINATION_REQUESTS',
  ShowRestaurantImageInInboxMessage = 'SHOW_RESTAURANT_IMAGE_IN_INBOX_MESSAGE',
  ShowTieredPricingUi = 'SHOW_TIERED_PRICING_UI',
  StripeEmbeddedPaymentElement = 'STRIPE_EMBEDDED_PAYMENT_ELEMENT',
  StripeEmbeddedPaymentElementAndroid = 'STRIPE_EMBEDDED_PAYMENT_ELEMENT_ANDROID',
  StripeLink = 'STRIPE_LINK',
  UseNominationShortCode = 'USE_NOMINATION_SHORT_CODE',
  WalletTopUpIssuesFunCoupons = 'WALLET_TOP_UP_ISSUES_FUN_COUPONS',
  WhileInUseLocationGeofenceDetection = 'WHILE_IN_USE_LOCATION_GEOFENCE_DETECTION',
  WindowShoppingAllowed = 'WINDOW_SHOPPING_ALLOWED'
}

export type Feature = {
  __typename?: 'Feature';
  feature: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type FeatureAttribute = {
  __typename?: 'FeatureAttribute';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FeatureFlagResponse = {
  __typename?: 'FeatureFlagResponse';
  feature: Scalars['String']['output'];
  has: Scalars['Boolean']['output'];
};

export type GuestList = {
  __typename?: 'GuestList';
  for?: Maybe<GuestListable>;
};

export type GuestListEntry = {
  __typename?: 'GuestListEntry';
  additional_guests?: Maybe<Scalars['Int']['output']>;
  code: Scalars['String']['output'];
  guestList: GuestList;
  id: Scalars['ID']['output'];
  invitedBy?: Maybe<GuestListEntry>;
  status: Scalars['String']['output'];
};

export type GuestListable = Event | Restaurant;

export type Heading = {
  __typename?: 'Heading';
  size: HeadingSize;
  text: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export enum HeadingSize {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6'
}

export type HeroCard = {
  __typename?: 'HeroCard';
  icon?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type HeroMedia = {
  __typename?: 'HeroMedia';
  caption?: Maybe<Scalars['String']['output']>;
  hero_media?: Maybe<Media>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type IconDescription = {
  __typename?: 'IconDescription';
  /**  Base64-encoded XML of an SVG icon  */
  svg: Scalars['String']['output'];
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum IconDescriptionFormat {
  Box = 'BOX',
  Bullet = 'BULLET'
}

export type IntercomSetting = {
  __typename?: 'IntercomSetting';
  enabled: Scalars['Boolean']['output'];
  initial_message?: Maybe<Scalars['String']['output']>;
};

export type Inventory = {
  __typename?: 'Inventory';
  heading?: Maybe<Scalars['String']['output']>;
};

export type InventoryItem = {
  __typename?: 'InventoryItem';
  accessType?: Maybe<AccessType>;
  coming_soon: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Media>;
  intercom: IntercomSetting;
  /**
   * Whether this ticket type is a bundle that includes multiple other ticket types.
   * Bundle ticket types are used for multi-day passes (e.g., Full Weekend).
   */
  isBundleTicketType: Scalars['Boolean']['output'];
  layout?: Maybe<Array<Maybe<LayoutTemplateBlock>>>;
  media: Array<Maybe<Media>>;
  min_membership_level?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /**
   * True when this item's access type requires identity verification. The
   * widget uses this to show a heads-up banner on checkout so members know
   * an IDV link is coming after purchase.
   */
  requires_idv: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

/**
 * Input for joining a membership waitlist.
 * Use this specific input type when creating new membership waitlist entries.
 */
export type JoinMembershipWaitlistInput = {
  /** Latitude coordinate (must be between -90 and 90) */
  lat?: InputMaybe<Scalars['Float']['input']>;
  /** Longitude coordinate (must be between -180 and 180) */
  lng?: InputMaybe<Scalars['Float']['input']>;
  /** Membership level (must be between 0 and 1000) */
  membership_level?: InputMaybe<Scalars['Int']['input']>;
  /** Stripe payment method ID */
  payment_method_id?: InputMaybe<Scalars['ID']['input']>;
  /** Stripe plan ID */
  plan_id?: InputMaybe<Scalars['ID']['input']>;
  /** Stripe plan promotion ID */
  plan_promotion_id?: InputMaybe<Scalars['ID']['input']>;
  reason: WaitlistReason;
};

/**
 * Generic input for joining a waitlist.
 * Currently supports membership waitlists. Fields are optional to support different waitlist types.
 * For new waitlist types, create a specific input type (e.g., JoinEventWaitlistInput).
 */
export type JoinWaitlistInput = {
  reason: WaitlistReason;
};

export type LayoutTemplate = {
  __typename?: 'LayoutTemplate';
  blocks: Array<Maybe<LayoutTemplateBlock>>;
};

export type LayoutTemplateBlock = ContactDetail | Divider | Faq | Heading | HeroCard | IconDescription | Inventory | LinesOfText | MarkdownContent | NeedToKnow | PreviewVideo;

export enum LayoutTemplateLocation {
  ProfileBody = 'PROFILE_BODY'
}

export type LibraryDateTimeFormats = {
  __typename?: 'LibraryDateTimeFormats';
  dateFns: DateTimeFormat;
  moment: DateTimeFormat;
};

export type LineItem = {
  __typename?: 'LineItem';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type LinesOfText = {
  __typename?: 'LinesOfText';
  lines: Array<Maybe<Scalars['String']['output']>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type Location = {
  __typename?: 'Location';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type MarkdownContent = {
  __typename?: 'MarkdownContent';
  content: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type Media = {
  __typename?: 'Media';
  caption?: Maybe<Scalars['String']['output']>;
  collection_name?: Maybe<Scalars['String']['output']>;
  custom_properties: MediaMeta;
  full_url?: Maybe<Scalars['String']['output']>;
  image_anchor?: Maybe<Scalars['String']['output']>;
  image_height?: Maybe<Scalars['Int']['output']>;
  image_width?: Maybe<Scalars['Int']['output']>;
  mime_type?: Maybe<Scalars['String']['output']>;
  original_url?: Maybe<Scalars['String']['output']>;
  preview_url?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

export type MediaMeta = {
  __typename?: 'MediaMeta';
  icon?: Maybe<Scalars['String']['output']>;
};

/** Defines actions the user can take, using the TakeAction GraphQL mutation. */
export enum MemberAction {
  ExtendGuestPass = 'EXTEND_GUEST_PASS',
  ReportScreenshot = 'REPORT_SCREENSHOT',
  ReportScreenRecording = 'REPORT_SCREEN_RECORDING',
  RequestMembershipInvite = 'REQUEST_MEMBERSHIP_INVITE'
}

export type Membership = {
  __typename?: 'Membership';
  benefits: Array<Maybe<MembershipBenefit>>;
  coming_soon: Scalars['Boolean']['output'];
  cover_image?: Maybe<Media>;
  description?: Maybe<Scalars['String']['output']>;
  descriptions: MembershipDescriptions;
  features?: Maybe<Array<Maybe<MembershipFeatures>>>;
  gate_type?: Maybe<Scalars['String']['output']>;
  level: Scalars['Int']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  mobile_layout?: Maybe<Array<Maybe<LayoutTemplateBlock>>>;
  name: Scalars['String']['output'];
  /**
   * Details of the nominator whose membership level grants access to this membership tier.
   * When populated, indicates that the user can bypass waitlist requirements through the
   * nominator's membership privileges. This is null when no nomination grant applies.
   */
  nomination_grant?: Maybe<NominationGrant>;
  plans: Array<Plan>;
  short_description?: Maybe<Scalars['String']['output']>;
  short_description_icon_content?: Maybe<Scalars['String']['output']>;
  short_description_icon_id?: Maybe<Scalars['Int']['output']>;
  value_props?: Maybe<ContentCollection>;
  waitlist_status?: Maybe<WaitlistStatus>;
};

export type MembershipBenefit = {
  __typename?: 'MembershipBenefit';
  label: Scalars['String']['output'];
  pivot?: Maybe<MembershipBenefitPivot>;
  unique_key: Scalars['String']['output'];
};

export type MembershipBenefitPivot = {
  __typename?: 'MembershipBenefitPivot';
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type MembershipDescriptions = {
  __typename?: 'MembershipDescriptions';
  cancel_button_text?: Maybe<Scalars['String']['output']>;
  choose_plan_button_text?: Maybe<Scalars['String']['output']>;
  coming_soon_cta?: Maybe<Scalars['String']['output']>;
  continue_button_text?: Maybe<Scalars['String']['output']>;
  disabled_cta?: Maybe<Scalars['String']['output']>;
  lockout_screen_body_content?: Maybe<Scalars['String']['output']>;
  plan_subscription_confirmation_screen_body_content?: Maybe<Scalars['String']['output']>;
  post_subscription_title?: Maybe<Scalars['String']['output']>;
  scroll_down_text?: Maybe<Scalars['String']['output']>;
  subscribe_button_text?: Maybe<Scalars['String']['output']>;
};

export type MembershipFeatureFields = {
  __typename?: 'MembershipFeatureFields';
  feature?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  highlighted?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
};

export type MembershipFeatures = {
  __typename?: 'MembershipFeatures';
  fields: MembershipFeatureFields;
  type: Scalars['String']['output'];
};

export enum MembershipInterval {
  Month = 'MONTH',
  Year = 'YEAR'
}

export type MembershipSubscription = {
  __typename?: 'MembershipSubscription';
  allow_opt_back_in?: Maybe<Scalars['Boolean']['output']>;
  canceled: Scalars['Boolean']['output'];
  created_at: Scalars['DateTime']['output'];
  credits_expiration?: Maybe<Scalars['DateTime']['output']>;
  ends_at?: Maybe<Scalars['DateTime']['output']>;
  level: Membership;
  on_grace_period: Scalars['Boolean']['output'];
  on_trial: Scalars['Boolean']['output'];
  plan: Plan;
  promotion?: Maybe<PlanPromotion>;
  trial_ends_at?: Maybe<Scalars['DateTime']['output']>;
  valid: Scalars['Boolean']['output'];
};

/**
 * Metadata for membership waitlist entries.
 * Contains information about the membership, plan, and payment details.
 */
export type MembershipWaitlistMeta = {
  __typename?: 'MembershipWaitlistMeta';
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  membership_level?: Maybe<Scalars['Int']['output']>;
  payment_method_id?: Maybe<Scalars['ID']['output']>;
  plan_id?: Maybe<Scalars['ID']['output']>;
  plan_promotion_id?: Maybe<Scalars['ID']['output']>;
};

export type Menu = {
  __typename?: 'Menu';
  name: Scalars['String']['output'];
  sections: Array<MenuSection>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MenuItem = {
  __typename?: 'MenuItem';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  options?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  price__currency?: Maybe<Scalars['String']['output']>;
};

export type MenuSection = {
  __typename?: 'MenuSection';
  description?: Maybe<Scalars['String']['output']>;
  items: Array<MenuItem>;
  name: Scalars['String']['output'];
};

export enum MessageCategory {
  Announcement = 'Announcement',
  Booking = 'Booking',
  Marketing = 'Marketing',
  Transactional = 'Transactional'
}

export enum MessageDisplayType {
  BottomDrawer = 'BottomDrawer',
  ModalBottom = 'ModalBottom',
  ModalCenter = 'ModalCenter',
  ModalTop = 'ModalTop',
  Notification = 'Notification',
  Toast = 'Toast'
}

export enum MessageSource {
  Braze = 'Braze',
  Concierge = 'Concierge',
  Event = 'Event',
  Membership = 'Membership',
  Reservation = 'Reservation',
  System = 'System'
}

/** WARNING: Changing or removing cases affects inventory history tables. */
export enum MinMembershipAction {
  Gate = 'GATE',
  Hide = 'HIDE'
}

export type MultipleDayAvailability = {
  __typename?: 'MultipleDayAvailability';
  data: Array<Maybe<Availability>>;
  date?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptDocumentVersion: DocumentVersion;
  createReservationCheckIn: ReservationCheckIn;
  guestListEntryRsvp: GuestListEntry;
  /**
   * Records when the user's device detected arrival at the restaurant via geofencing.
   * Updates the device_geofence_detected_at timestamp on the reservation.
   */
  recordGeofenceArrival: Reservation;
};


export type MutationAcceptDocumentVersionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateReservationCheckInArgs = {
  check_in: Scalars['String']['input'];
  reservation_id: Scalars['ID']['input'];
};


export type MutationGuestListEntryRsvpArgs = {
  code: Scalars['String']['input'];
};


export type MutationRecordGeofenceArrivalArgs = {
  reservation_id: Scalars['ID']['input'];
};

export type NeedToKnow = {
  __typename?: 'NeedToKnow';
  version: Scalars['Int']['output'];
};

export type NeedToKnows = {
  __typename?: 'NeedToKnows';
  description?: Maybe<Scalars['String']['output']>;
  expires_at?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
};

export type Neighborhood = {
  __typename?: 'Neighborhood';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Nomination = {
  __typename?: 'Nomination';
  accepted_at?: Maybe<Scalars['String']['output']>;
  acknowledged?: Maybe<Scalars['Boolean']['output']>;
  availableRewards?: Maybe<Array<Maybe<AvailableReward>>>;
  code?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTime']['output'];
  display_name?: Maybe<Scalars['String']['output']>;
  display_phone?: Maybe<Scalars['String']['output']>;
  display_status?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_referral?: Maybe<Scalars['Boolean']['output']>;
  nominator?: Maybe<User>;
  nominee?: Maybe<User>;
  rewards?: Maybe<Array<Maybe<Reward>>>;
  statement?: Maybe<Scalars['String']['output']>;
};

/**
 * Information about the nominator whose membership grants the nominee bypass privileges
 * for geofenced waitlists. This represents the qualifying nominator who enables access.
 */
export type NominationGrant = {
  __typename?: 'NominationGrant';
  /** The nominator's first name */
  first_name: Scalars['String']['output'];
  /** The nominator's last name */
  last_name: Scalars['String']['output'];
  /** The nominator's membership level (numeric tier, e.g., 100, 200, 300) */
  membership_level: Scalars['Int']['output'];
  /** The name of the nominator's membership tier (e.g., 'Premium', 'Elite'), if available */
  membership_name?: Maybe<Scalars['String']['output']>;
};

export enum NominationStatus {
  Awarded = 'AWARDED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Earned = 'EARNED',
  Expired = 'EXPIRED',
  Nominated = 'NOMINATED',
  Requested = 'REQUESTED',
  Resent = 'RESENT',
  Sent = 'SENT',
  Waitlist = 'WAITLIST'
}

export type NominationToken = {
  __typename?: 'NominationToken';
  claimed_count: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  deep_link_url: Scalars['String']['output'];
  expires_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  max_claims: Scalars['Int']['output'];
  nominations_remaining: Scalars['Int']['output'];
  nominator_name?: Maybe<Scalars['String']['output']>;
  remaining_claims: Scalars['Int']['output'];
  token: Scalars['String']['output'];
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
  /** Number of total available items. */
  total: Scalars['Int']['output'];
};

export type PaymentType = {
  __typename?: 'PaymentType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type Plan = {
  __typename?: 'Plan';
  coming_soon: Scalars['Boolean']['output'];
  currency: Currency;
  descriptions: PlanDescriptions;
  /** The price with promotion applied */
  display_price: Scalars['Int']['output'];
  /** Display Price, formatted as currency */
  display_price__currency?: Maybe<Scalars['String']['output']>;
  /** The combined features of the plan and its active promotion */
  features?: Maybe<Array<Maybe<PlanFeatures>>>;
  id: Scalars['ID']['output'];
  interval: MembershipInterval;
  /** This plan's line items for the price breakdown */
  line_items?: Maybe<Array<Maybe<LineItem>>>;
  name?: Maybe<Scalars['String']['output']>;
  /** The original price of the plan */
  price: Scalars['Int']['output'];
  /** Price, formatted as currency */
  price__currency?: Maybe<Scalars['String']['output']>;
  /** Plan's price schedule */
  price_schedule: Array<Maybe<PriceSchedule>>;
  /** This plan's active promotion, specific to the current user */
  promotion?: Maybe<PlanPromotion>;
  /** All upcoming promotions for this plan that are visible to the current user */
  promotions?: Maybe<Array<Maybe<PlanPromotion>>>;
  /**
   * The prorate credit amount in cents that would be applied as a discount if the user
   * upgrades to this plan's membership tier. Calculated from the unused time remaining on the
   * user's current billing period. Null when not applicable (same level, lower level,
   * no active subscription, or user is not authenticated).
   */
  prorate_credit?: Maybe<Scalars['Int']['output']>;
  /**
   * The prorate credit amount formatted as currency (e.g., "$150").
   * Null when prorate_credit is null.
   */
  prorate_credit__currency?: Maybe<Scalars['String']['output']>;
  requires_payment_method: Scalars['Boolean']['output'];
  /** Active thresholds configured for this plan */
  thresholds: Array<PlanThreshold>;
};

export type PlanDescriptions = {
  __typename?: 'PlanDescriptions';
  choose_plan_button_caption?: Maybe<Scalars['String']['output']>;
  choose_plan_button_text?: Maybe<Scalars['String']['output']>;
  payment_sheet_details?: Maybe<Scalars['String']['output']>;
  plan_name_caption?: Maybe<Scalars['String']['output']>;
  plan_name_eyebrow?: Maybe<Scalars['String']['output']>;
  plan_price_caption?: Maybe<Scalars['String']['output']>;
};

export type PlanFeatureFields = {
  __typename?: 'PlanFeatureFields';
  cta_text?: Maybe<Scalars['String']['output']>;
  cta_text_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  expandable?: Maybe<Scalars['Boolean']['output']>;
  feature?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  highlighted?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  title_icon_content?: Maybe<Scalars['String']['output']>;
  title_icon_id?: Maybe<Scalars['Int']['output']>;
};

export type PlanFeatures = {
  __typename?: 'PlanFeatures';
  fields: PlanFeatureFields;
  type: Scalars['String']['output'];
};

export type PlanPromotion = {
  __typename?: 'PlanPromotion';
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Used to override the title on the Sales Page */
  alternate_title?: Maybe<Scalars['String']['output']>;
  coming_soon: Scalars['Boolean']['output'];
  descriptions: PlanPromotionDescriptions;
  /**  Display price as currency  */
  display_price__currency?: Maybe<Scalars['String']['output']>;
  /**  String representation of the duration: forever or once  */
  duration: Scalars['String']['output'];
  features?: Maybe<Array<Maybe<PlanFeatures>>>;
  /**  The interval (in months) that the gift points should be scheduled for (1=monthly, 3=quarterly, 12=all at once)  */
  gifted_point_cadence: Scalars['Int']['output'];
  /**  The total number of points gifted with this promotion  */
  gifted_points: Scalars['Int']['output'];
  /**  The total currency value of the gifted points  */
  gifted_points__currency: Scalars['String']['output'];
  /** The plan_promotion_id to send to the server when creating a new subscription */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** The order to show the promotions */
  order: Scalars['Int']['output'];
  /** The date and time the plan's charge starts */
  plan_charge_start: Scalars['String']['output'];
  /** The total display price of the plan */
  plan_total_display_price: Scalars['String']['output'];
  /** Plan's price schedule */
  price_schedule: Array<Maybe<PriceSchedule>>;
  /**  Whether a payment method is needed  */
  requires_payment_method: Scalars['Boolean']['output'];
  /** Active thresholds configured for this plan promotion */
  thresholds: Array<PlanThreshold>;
  /** The number of days of included trial before billing */
  trial_days: Scalars['Int']['output'];
  /** Whether this promotion should be shown to the user */
  visible?: Maybe<Scalars['Boolean']['output']>;
  /**  Whether to allow window shopping experience  */
  window_shopping_allowed: Scalars['Boolean']['output'];
};

export type PlanPromotionDescriptions = {
  __typename?: 'PlanPromotionDescriptions';
  choose_plan_button_caption?: Maybe<Scalars['String']['output']>;
  choose_plan_button_text?: Maybe<Scalars['String']['output']>;
  credit_expiration_text?: Maybe<Scalars['String']['output']>;
  payment_sheet_details?: Maybe<Scalars['String']['output']>;
  plan_name_caption?: Maybe<Scalars['String']['output']>;
  plan_name_eyebrow?: Maybe<Scalars['String']['output']>;
  plan_price_caption?: Maybe<Scalars['String']['output']>;
  promo_card_overlay_text?: Maybe<Scalars['String']['output']>;
  promo_card_title?: Maybe<Scalars['String']['output']>;
};

export type PlanThreshold = {
  __typename?: 'PlanThreshold';
  active: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  priority: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: PlanThresholdType;
};

export type PlanThresholdStatus = {
  __typename?: 'PlanThresholdStatus';
  active: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  priority: Scalars['Int']['output'];
  status: ThresholdStatusDetail;
  title?: Maybe<Scalars['String']['output']>;
  type: PlanThresholdType;
};

export enum PlanThresholdType {
  BookingLimit = 'BOOKING_LIMIT'
}

export type Point = {
  __typename?: 'Point';
  amount: Scalars['Int']['output'];
  available_at?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['String']['output'];
  description: Scalars['String']['output'];
  expires_at: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updated_at: Scalars['String']['output'];
};

export type PreviewVideo = {
  __typename?: 'PreviewVideo';
  image?: Maybe<Scalars['String']['output']>;
  play_button_text?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Scalars['String']['output']>;
};

export type PriceSchedule = {
  __typename?: 'PriceSchedule';
  items: Array<Maybe<LineItem>>;
  label: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type Product = {
  __typename?: 'Product';
  description?: Maybe<Scalars['String']['output']>;
  features: Array<Maybe<ProductFeatures>>;
  id: Scalars['ID']['output'];
  is_sold_out: Scalars['Boolean']['output'];
  min_membership_level?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  price__currency?: Maybe<Scalars['String']['output']>;
};

export type ProductFeatures = {
  __typename?: 'ProductFeatures';
  attributes: Array<Maybe<FeatureAttribute>>;
  title: Scalars['String']['output'];
};

export type Production = {
  __typename?: 'Production';
  description?: Maybe<Scalars['String']['output']>;
  events: Array<Maybe<Event>>;
  image_url?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ticketTypes: Array<Maybe<TicketType>>;
};

export type Promoter = {
  __typename?: 'Promoter';
  full_name: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type Promotion = {
  __typename?: 'Promotion';
  details?: Maybe<PromotionDetails>;
  id: Scalars['ID']['output'];
  main_image?: Maybe<Media>;
  mini?: Maybe<PromotionMini>;
  name: Scalars['String']['output'];
  promo_end_date?: Maybe<Scalars['String']['output']>;
  promo_start_date?: Maybe<Scalars['String']['output']>;
  restaurants: Array<Restaurant>;
};

export type PromotionDetails = {
  __typename?: 'PromotionDetails';
  background_color?: Maybe<Scalars['String']['output']>;
  eyebrow?: Maybe<Scalars['String']['output']>;
  fine_print?: Maybe<Scalars['String']['output']>;
  hero_image?: Maybe<Media>;
  modal_content?: Maybe<Scalars['String']['output']>;
  modal_title?: Maybe<Scalars['String']['output']>;
};

export type PromotionMini = {
  __typename?: 'PromotionMini';
  content?: Maybe<Scalars['String']['output']>;
  content_color?: Maybe<Scalars['String']['output']>;
  cta_text?: Maybe<Scalars['String']['output']>;
  cta_text_color?: Maybe<Scalars['String']['output']>;
  mini_image?: Maybe<Media>;
  promo_title?: Maybe<Scalars['String']['output']>;
};

export type Publisher = {
  __typename?: 'Publisher';
  articles: Array<Article>;
  domain?: Maybe<Scalars['String']['output']>;
  logo_image_url?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  accessTypes: Array<Maybe<AccessType>>;
  addOnInventory: Array<Maybe<EventInventory>>;
  area?: Maybe<Area>;
  areas: AreaPaginator;
  article?: Maybe<Article>;
  content: Content;
  contentCollection?: Maybe<ContentCollection>;
  contentCollections?: Maybe<Array<ContentCollection>>;
  countryCodes: Array<Maybe<CountryCode>>;
  customRequestSettings: CustomRequestSettings;
  dateTimeFormats: LibraryDateTimeFormats;
  getAvailableSubscriptionGroups: Array<Maybe<SubscriptionGroup>>;
  getBookableEvents: Array<Maybe<Restaurant>>;
  getEventsByRestaurantId: Array<Maybe<Event>>;
  getGuestListEntry?: Maybe<GuestListEntry>;
  getMultipleDayRestaurantAvailability: Array<Maybe<MultipleDayAvailability>>;
  getNominationByCode?: Maybe<Nomination>;
  getNominationToken?: Maybe<NominationToken>;
  /**
   * Get areas available for public browsing.
   * Returns active local areas that have public restaurants.
   * Used for unauthenticated browsing (Apple 5.1.1 compliance).
   */
  getPublicAreas: Array<Area>;
  /**
   * Get regions with children for public browsing.
   * Returns active regions with their active child areas in hierarchical format.
   * Used for the accordion-style location filter in unauthenticated browsing (Apple 5.1.1 compliance).
   */
  getPublicRegions: Array<Area>;
  /**
   * Get public restaurants with optional filtering.
   * Used for unauthenticated browsing (Apple 5.1.1 compliance).
   * Includes global area restaurants when filtering by area.
   */
  getPublicRestaurants: Array<Maybe<Restaurant>>;
  getRestaurant?: Maybe<RestaurantBasicDetail>;
  getRestaurantAvailability: Array<Maybe<Availability>>;
  getRestaurantDetailAvailability: RestaurantDetailAvailability;
  getRestaurantDetailDates: Array<Maybe<RestaurantDateSummary>>;
  hasFeatureFlag: FeatureFlagResponse;
  hasFeatureFlagPortal: FeatureFlagResponse;
  hasFeatureFlags: Array<FeatureFlagResponse>;
  me: Concierge;
  membershipBenefits: Array<MembershipBenefit>;
  memberships: Array<Membership>;
  promoters: Array<Maybe<Promoter>>;
  /**
   * Get a single public restaurant by ID.
   * Used for unauthenticated browsing (Apple 5.1.1 compliance).
   * Returns null if the restaurant doesn't meet public visibility criteria.
   */
  publicRestaurant?: Maybe<Restaurant>;
  referralCode?: Maybe<ReferralCode>;
  regions: Array<Maybe<Area>>;
  requiredDocuments: Array<Maybe<DocumentVersion>>;
  reservations: ReservationPaginator;
  restaurant?: Maybe<Restaurant>;
  restaurantSearch: RestaurantPaginator;
  restaurantSkipMinPromos: Array<RestaurantSkipMinPromo>;
  restaurantsByArea: Array<Maybe<Restaurant>>;
  skipMinPromos: Array<SkipMinPromo>;
  ticket?: Maybe<Ticket>;
  ticketInventory: Array<Maybe<EventInventory>>;
  translations: AppTranslation;
};


export type QueryAccessTypesArgs = {
  excludeBundles?: InputMaybe<Scalars['Boolean']['input']>;
  forEvent: Scalars['ID']['input'];
};


export type QueryAddOnInventoryArgs = {
  forItem: Scalars['ID']['input'];
};


export type QueryAreaArgs = {
  id?: InputMaybe<Scalars['IntID']['input']>;
};


export type QueryAreasArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryArticleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryContentCollectionArgs = {
  area_id?: InputMaybe<Scalars['ID']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContentCollectionsArgs = {
  area_id: Scalars['ID']['input'];
  end_date?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  to: ContentCollectionArea;
};


export type QueryCustomRequestSettingsArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  party_size?: InputMaybe<Scalars['Int']['input']>;
  seating_types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  start_time?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEventsByRestaurantIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetGuestListEntryArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetMultipleDayRestaurantAvailabilityArgs = {
  end_date: Scalars['String']['input'];
  end_time?: InputMaybe<Scalars['String']['input']>;
  party_size?: InputMaybe<Scalars['Int']['input']>;
  restaurant_id: Scalars['ID']['input'];
  start_date: Scalars['String']['input'];
  start_time?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetNominationByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetNominationTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetPublicRestaurantsArgs = {
  area_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRestaurantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRestaurantAvailabilityArgs = {
  end_date?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['String']['input']>;
  party_size: Scalars['Int']['input'];
  restaurant_id: Scalars['ID']['input'];
  start_date?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRestaurantDetailAvailabilityArgs = {
  date: Scalars['String']['input'];
  end_time?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  include_fully_booked?: InputMaybe<Scalars['Boolean']['input']>;
  party_size?: InputMaybe<Scalars['Int']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRestaurantDetailDatesArgs = {
  end_date: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  party_size?: InputMaybe<Scalars['Int']['input']>;
  start_date: Scalars['String']['input'];
};


export type QueryHasFeatureFlagArgs = {
  feature: Scalars['String']['input'];
};


export type QueryHasFeatureFlagPortalArgs = {
  feature: Scalars['String']['input'];
  restaurantId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHasFeatureFlagsArgs = {
  features: Array<Scalars['String']['input']>;
};


export type QueryMembershipsArgs = {
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryPromotersArgs = {
  forEvent: Scalars['ID']['input'];
};


export type QueryPublicRestaurantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReferralCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryReservationsArgs = {
  byStatus?: InputMaybe<Scalars['String']['input']>;
  byStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<QueryReservationsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRestaurantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRestaurantSearchArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
};


export type QueryRestaurantSkipMinPromosArgs = {
  forDate?: InputMaybe<Scalars['String']['input']>;
  forPartySize?: InputMaybe<Scalars['Int']['input']>;
  givenMinimumSpend?: InputMaybe<Scalars['Float']['input']>;
  restaurant: Scalars['ID']['input'];
};


export type QueryRestaurantsByAreaArgs = {
  area_id: Scalars['ID']['input'];
  end_date?: InputMaybe<Scalars['String']['input']>;
  party_size: Scalars['Int']['input'];
  start_date: Scalars['String']['input'];
};


export type QuerySkipMinPromosArgs = {
  current?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTicketArgs = {
  uuid: Scalars['String']['input'];
};


export type QueryTicketInventoryArgs = {
  confirmedDate?: InputMaybe<Scalars['String']['input']>;
  forAccessType?: InputMaybe<Scalars['ID']['input']>;
  forEvent: Scalars['ID']['input'];
};


export type QueryTranslationsArgs = {
  language: Scalars['String']['input'];
};

/** Allowed column names for Query.reservations.orderBy. */
export enum QueryReservationsOrderByColumn {
  CreatedAt = 'CREATED_AT',
  ReservationAt = 'RESERVATION_AT',
  TableMinimum = 'TABLE_MINIMUM'
}

/** Order by clause for Query.reservations.orderBy. */
export type QueryReservationsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryReservationsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

export type QuestionAnswer = {
  __typename?: 'QuestionAnswer';
  answer: Scalars['String']['output'];
  question?: Maybe<Scalars['String']['output']>;
};

export type Receipt = {
  __typename?: 'Receipt';
  additional_tip?: Maybe<Scalars['Float']['output']>;
  additional_tip__currency?: Maybe<Scalars['String']['output']>;
  additional_tip_value__currency?: Maybe<Scalars['String']['output']>;
  balance__currency?: Maybe<Scalars['String']['output']>;
  custom_tip?: Maybe<Scalars['Float']['output']>;
  custom_tip__currency?: Maybe<Scalars['String']['output']>;
  display_total__currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  included_tip_amount__currency?: Maybe<Scalars['String']['output']>;
  reached_sub_total__currency?: Maybe<Scalars['String']['output']>;
  reservation?: Maybe<Reservation>;
  service_charge?: Maybe<Scalars['Float']['output']>;
  service_charge__currency?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  sub_total?: Maybe<Scalars['Float']['output']>;
  sub_total__currency?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
  tax__currency?: Maybe<Scalars['String']['output']>;
  tax_total__currency?: Maybe<Scalars['String']['output']>;
  tip_percentage?: Maybe<Scalars['Float']['output']>;
  tip_total__currency?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  total__currency?: Maybe<Scalars['String']['output']>;
  total_charged?: Maybe<Scalars['Float']['output']>;
  total_charged__currency?: Maybe<Scalars['String']['output']>;
};

export type ReceiptItem = {
  __typename?: 'ReceiptItem';
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  price__currency?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type ReceiptMessage = {
  __typename?: 'ReceiptMessage';
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ReceiptValue = {
  __typename?: 'ReceiptValue';
  amount?: Maybe<Scalars['Float']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type ReferralCode = {
  __typename?: 'ReferralCode';
  active: Scalars['Boolean']['output'];
  auto_approve_member: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  created_at: Scalars['String']['output'];
  deactivated_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_primary: Scalars['Boolean']['output'];
  no_guest_pass_eligibility: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  popup_cta_button_text?: Maybe<Scalars['String']['output']>;
  popup_cta_button_url?: Maybe<Scalars['String']['output']>;
  popup_deactivate_at?: Maybe<Scalars['String']['output']>;
  popup_description?: Maybe<Scalars['String']['output']>;
  popup_eyebrow?: Maybe<Scalars['String']['output']>;
  popup_image_url?: Maybe<Scalars['String']['output']>;
  popup_membership_level?: Maybe<Scalars['Int']['output']>;
  popup_show_to_paid_users: Scalars['Boolean']['output'];
  popup_title?: Maybe<Scalars['String']['output']>;
  referral_type: ReferralType;
  updated_at: Scalars['String']['output'];
};

/** Type of referral code */
export enum ReferralType {
  Discount = 'Discount',
  Event = 'Event',
  EventNfc = 'EventNFC',
  Gift = 'Gift',
  Invite = 'Invite',
  Nomination = 'Nomination',
  Partnership = 'Partnership',
  Standard = 'Standard',
  Trial = 'Trial'
}

export type Reservation = {
  __typename?: 'Reservation';
  booking_link: Scalars['String']['output'];
  booking_link_status: BookingLinkStatus;
  concierge_booking?: Maybe<ConciergeBooking>;
  created_at: Scalars['DateTime']['output'];
  party_size: Scalars['Int']['output'];
  price_per_person__currency?: Maybe<Scalars['String']['output']>;
  reservation_at_local__formatted: DateTimeFormat;
  reservation_at_local__request_formatted: DateTimeFormat;
  restaurant: Restaurant;
  table_minimum__currency?: Maybe<Scalars['String']['output']>;
  table_type?: Maybe<Scalars['String']['output']>;
  user: User;
  uuid: Scalars['String']['output'];
};

export type ReservationChangeProposal = {
  __typename?: 'ReservationChangeProposal';
  approval_deadline_at?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  proposedTableType?: Maybe<TableType>;
  proposed_party_size?: Maybe<Scalars['Int']['output']>;
  proposed_price_per_person?: Maybe<Scalars['Int']['output']>;
  proposed_price_per_person__currency?: Maybe<Scalars['String']['output']>;
  proposed_reservation_time__user_formatted?: Maybe<DateFormats>;
  sub_title?: Maybe<Scalars['String']['output']>;
  table_minimum_if_accepted?: Maybe<Scalars['Int']['output']>;
  table_minimum_if_accepted__currency?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type ReservationCheckIn = {
  __typename?: 'ReservationCheckIn';
  check_in: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  reservation_id?: Maybe<Scalars['ID']['output']>;
};

export enum ReservationDietaryAllergies {
  Dairy = 'DAIRY',
  Eggs = 'EGGS',
  Fish = 'FISH',
  Other = 'OTHER',
  Peanuts = 'PEANUTS',
  Shellfish = 'SHELLFISH',
  Soy = 'SOY',
  TreeNuts = 'TREE_NUTS',
  Wheat = 'WHEAT'
}

export enum ReservationDietaryPreferences {
  GlutenFree = 'GLUTEN_FREE',
  Halal = 'HALAL',
  KosherStyle = 'KOSHER_STYLE',
  Other = 'OTHER',
  Paleo = 'PALEO',
  Pescatarian = 'PESCATARIAN',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN'
}

export type ReservationItem = {
  __typename?: 'ReservationItem';
  guests: Scalars['Int']['output'];
  item: ReservationItemType;
  price__currency?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
};

export type ReservationItemType = Product | TicketType;

export enum ReservationOccasion {
  Anniversary = 'ANNIVERSARY',
  Birthday = 'BIRTHDAY',
  Business = 'BUSINESS',
  Other = 'OTHER'
}

/** A paginated list of Reservation items. */
export type ReservationPaginator = {
  __typename?: 'ReservationPaginator';
  /** A list of Reservation items. */
  data: Array<Reservation>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ResponseTimeDetails = {
  __typename?: 'ResponseTimeDetails';
  average_response_time_as_text?: Maybe<Scalars['String']['output']>;
  average_response_time_in_minutes?: Maybe<Scalars['Int']['output']>;
  average_response_time_verbiage?: Maybe<Scalars['String']['output']>;
};

export type Restaurant = {
  __typename?: 'Restaurant';
  address?: Maybe<Scalars['String']['output']>;
  allow_special_request?: Maybe<Array<Maybe<AllowSpecialRequest>>>;
  allow_subscription_to_coming_soon?: Maybe<Scalars['Boolean']['output']>;
  allowedPaymentTypes: Array<Maybe<PaymentType>>;
  area?: Maybe<Area>;
  articles: Array<Article>;
  availability: Array<Maybe<Availability>>;
  availability_notifications?: Maybe<Array<Maybe<AvailabilityNotification>>>;
  average_response_time_in_minutes?: Maybe<Scalars['Int']['output']>;
  awards?: Maybe<Array<Award>>;
  coming_soon?: Maybe<Scalars['Boolean']['output']>;
  cuisine?: Maybe<Cuisine>;
  cuisines?: Maybe<Array<Cuisine>>;
  custom_request_min_membership_level?: Maybe<Scalars['Int']['output']>;
  custom_request_response_time?: Maybe<ResponseTimeDetails>;
  deep_link?: Maybe<Scalars['String']['output']>;
  descriptors?: Maybe<Array<Descriptor>>;
  disclosure_link_label?: Maybe<Scalars['String']['output']>;
  disclosure_link_url?: Maybe<Scalars['String']['output']>;
  disclosure_text?: Maybe<Scalars['String']['output']>;
  dynamic_image?: Maybe<Media>;
  events: Array<Maybe<Event>>;
  expanded_tc?: Maybe<Scalars['String']['output']>;
  expanded_tc_opt_in_label?: Maybe<Scalars['String']['output']>;
  expanded_tc_title?: Maybe<Scalars['String']['output']>;
  externalArticles: Array<ExternalArticle>;
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fun_fact?: Maybe<Scalars['String']['output']>;
  galleryMedia?: Maybe<Array<Media>>;
  has_dorsia_pay_lite?: Maybe<Scalars['Boolean']['output']>;
  has_frictionless?: Maybe<Scalars['Boolean']['output']>;
  has_promo?: Maybe<Scalars['Boolean']['output']>;
  heroMedia?: Maybe<Array<Media>>;
  hide_action_bar?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_event?: Maybe<Scalars['Boolean']['output']>;
  is_new_restaurant?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  launching_at?: Maybe<Scalars['String']['output']>;
  long_description?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  max_size?: Maybe<Scalars['Int']['output']>;
  medium_description?: Maybe<Scalars['String']['output']>;
  menu?: Maybe<Menu>;
  menus?: Maybe<Array<Menu>>;
  merchandising_marketing_opt_in_label?: Maybe<Scalars['String']['output']>;
  merchandising_marketing_opt_in_pre_selected?: Maybe<Scalars['Boolean']['output']>;
  merchandising_policy?: Maybe<Scalars['String']['output']>;
  merchandising_policy_opt_in_label?: Maybe<Scalars['String']['output']>;
  merchandising_policy_title?: Maybe<Scalars['String']['output']>;
  min_membership_level?: Maybe<Scalars['Int']['output']>;
  min_size?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  need_to_knows?: Maybe<Array<Maybe<NeedToKnows>>>;
  neighborhood?: Maybe<Neighborhood>;
  phone?: Maybe<Scalars['String']['output']>;
  phone_formatted?: Maybe<Scalars['String']['output']>;
  phrases: RestaurantPhrases;
  price_range_indicator?: Maybe<Scalars['String']['output']>;
  price_starting_at__currency?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Maybe<Product>>>;
  profile_body_template?: Maybe<LayoutTemplate>;
  promotions: Array<Maybe<Promotion>>;
  required_idv_levels?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** @deprecated Use required_idv_levels instead */
  requires_idv_for_events?: Maybe<Scalars['Boolean']['output']>;
  reservation_check_in_enabled?: Maybe<Scalars['Boolean']['output']>;
  reservations_open_at?: Maybe<Scalars['String']['output']>;
  review_bar_description?: Maybe<Scalars['String']['output']>;
  short_description?: Maybe<Scalars['String']['output']>;
  show_merchandising_tax_and_tip?: Maybe<Scalars['Boolean']['output']>;
  skipMinPromos: Array<SkipMinPromo>;
  special_request_days?: Maybe<SpecialRequestDaysAllowed>;
  splashImage?: Maybe<Media>;
  subscribed_to_coming_soon?: Maybe<Scalars['Boolean']['output']>;
  tall_crop_image_url?: Maybe<Scalars['String']['output']>;
  thumbnail_crop_image_url?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  transparentLogo?: Maybe<Media>;
  transparent_logo_image_url?: Maybe<Scalars['String']['output']>;
  two_step_deep_link?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  uses_layout_templates?: Maybe<Scalars['Boolean']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  wide_crop_image_url?: Maybe<Scalars['String']['output']>;
};


export type RestaurantAvailabilityArgs = {
  end_date?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<Scalars['String']['input']>;
  party_size: Scalars['Int']['input'];
  start_date?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['String']['input']>;
};

export type RestaurantArticle = {
  __typename?: 'RestaurantArticle';
  priority?: Maybe<Scalars['Int']['output']>;
};

export type RestaurantAward = {
  __typename?: 'RestaurantAward';
  award_id: Scalars['ID']['output'];
  extra?: Maybe<Scalars['String']['output']>;
  restaurant_id: Scalars['ID']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type RestaurantBasicDetail = {
  __typename?: 'RestaurantBasicDetail';
  heroMedia?: Maybe<Array<Media>>;
  long_description?: Maybe<Scalars['String']['output']>;
  medium_description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  short_description?: Maybe<Scalars['String']['output']>;
  transparentLogo?: Maybe<Media>;
};

export type RestaurantDateSummary = {
  __typename?: 'RestaurantDateSummary';
  allow_special_request: Scalars['Boolean']['output'];
  amount_of_tables: Scalars['Int']['output'];
  amount_of_tables_label?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  has_waitlist_gated?: Maybe<Scalars['Boolean']['output']>;
};

export type RestaurantDetailAvailability = {
  __typename?: 'RestaurantDetailAvailability';
  date: Scalars['String']['output'];
  groups: Array<Maybe<Availability>>;
};

export type RestaurantExternalArticle = {
  __typename?: 'RestaurantExternalArticle';
  priority?: Maybe<Scalars['Int']['output']>;
};

/** A paginated list of Restaurant items. */
export type RestaurantPaginator = {
  __typename?: 'RestaurantPaginator';
  /** A list of Restaurant items. */
  data: Array<Restaurant>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type RestaurantPhrases = {
  __typename?: 'RestaurantPhrases';
  access_types?: Maybe<Scalars['String']['output']>;
  additional_tip?: Maybe<Scalars['String']['output']>;
  book_now?: Maybe<Scalars['String']['output']>;
  choose_a_table_heading?: Maybe<Scalars['String']['output']>;
  choose_access_type_heading?: Maybe<Scalars['String']['output']>;
  notify_me?: Maybe<Scalars['String']['output']>;
  payment_method_for_overages?: Maybe<Scalars['String']['output']>;
  review_order_cta?: Maybe<Scalars['String']['output']>;
  sold_out?: Maybe<Scalars['String']['output']>;
  sold_out_error_description?: Maybe<Scalars['String']['output']>;
  sold_out_error_title?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['String']['output']>;
  table_minimum?: Maybe<Scalars['String']['output']>;
  tickets?: Maybe<Scalars['String']['output']>;
  tip_included?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
};

export type RestaurantSkipMinPromo = {
  __typename?: 'RestaurantSkipMinPromo';
  drinking_age_message?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['DateTime']['output']>;
  hide_explainer?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  itemImage?: Maybe<Media>;
  item_name: Scalars['String']['output'];
  item_price: Scalars['Float']['output'];
  item_price__currency: Scalars['String']['output'];
  max_minimum_spend: Scalars['Float']['output'];
  min_minimum_spend: Scalars['Float']['output'];
  opt_in_message?: Maybe<Scalars['String']['output']>;
  payment_callout?: Maybe<Scalars['String']['output']>;
  payment_info?: Maybe<Scalars['String']['output']>;
  skipMinPromo?: Maybe<SkipMinPromo>;
  start_date?: Maybe<Scalars['DateTime']['output']>;
};

export enum RestaurantTypeFilter {
  Both = 'BOTH',
  Event = 'EVENT',
  Restaurant = 'RESTAURANT'
}

export type Reward = {
  __typename?: 'Reward';
  amount: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  display_text: Scalars['String']['output'];
  name: Scalars['String']['output'];
  origin: Array<RewardOrigin>;
  type: RewardType;
};

export type RewardOrigin = {
  __typename?: 'RewardOrigin';
  id: Scalars['ID']['output'];
  link: RewardOriginLink;
  type: Scalars['String']['output'];
};

export type RewardOriginLink = MembershipSubscription | Nomination;

export enum RewardType {
  SuccessfulMembershipConversion = 'SUCCESSFUL_MEMBERSHIP_CONVERSION',
  SuccessfulNomination = 'SUCCESSFUL_NOMINATION'
}

export type ServiceCharge = {
  __typename?: 'ServiceCharge';
  amount?: Maybe<Scalars['Float']['output']>;
  amount__currency?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type ServiceChargeCurrency = {
  __typename?: 'ServiceChargeCurrency';
  amount?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type SkipMinPromo = {
  __typename?: 'SkipMinPromo';
  default_drinking_age_message?: Maybe<Scalars['String']['output']>;
  default_end_date?: Maybe<Scalars['DateTime']['output']>;
  default_item_name: Scalars['String']['output'];
  default_item_price: Scalars['Float']['output'];
  default_opt_in_message?: Maybe<Scalars['String']['output']>;
  default_payment_callout?: Maybe<Scalars['String']['output']>;
  default_payment_info?: Maybe<Scalars['String']['output']>;
  default_start_date?: Maybe<Scalars['DateTime']['output']>;
  details_markdown: Scalars['String']['output'];
  drinking_age_required?: Maybe<Scalars['Boolean']['output']>;
  explainer: Scalars['String']['output'];
  iconImage?: Maybe<Media>;
  id: Scalars['ID']['output'];
  itemImage?: Maybe<Media>;
  logoImage?: Maybe<Media>;
  name: Scalars['String']['output'];
  opt_in_required?: Maybe<Scalars['Boolean']['output']>;
  pivot?: Maybe<RestaurantSkipMinPromo>;
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export type SpecialRequestDaysAllowed = {
  __typename?: 'SpecialRequestDaysAllowed';
  fri?: Maybe<Scalars['Boolean']['output']>;
  mon?: Maybe<Scalars['Boolean']['output']>;
  sat?: Maybe<Scalars['Boolean']['output']>;
  sun?: Maybe<Scalars['Boolean']['output']>;
  thu?: Maybe<Scalars['Boolean']['output']>;
  tue?: Maybe<Scalars['Boolean']['output']>;
  wed?: Maybe<Scalars['Boolean']['output']>;
};

export type SubscriptionGroup = {
  __typename?: 'SubscriptionGroup';
  channel: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  message: Scalars['String']['output'];
};

export type TableType = {
  __typename?: 'TableType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Tag = {
  __typename?: 'Tag';
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Team = {
  __typename?: 'Team';
  name: Scalars['String']['output'];
};

export enum ThresholdPeriod {
  Lifetime = 'LIFETIME',
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

export type ThresholdStatusDetail = {
  __typename?: 'ThresholdStatusDetail';
  current?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  period?: Maybe<ThresholdPeriod>;
  period_label?: Maybe<Scalars['String']['output']>;
  remaining?: Maybe<Scalars['Int']['output']>;
};

export type Ticket = {
  __typename?: 'Ticket';
  admit_quantity: Scalars['Int']['output'];
  apple_wallet_pass?: Maybe<Scalars['String']['output']>;
  barcode_contents: Scalars['String']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  event: Event;
  google_wallet_pass?: Maybe<Scalars['String']['output']>;
  reservation?: Maybe<Reservation>;
  status: Scalars['String']['output'];
  ticketType: TicketType;
  user?: Maybe<User>;
  uuid: Scalars['String']['output'];
};

export type TicketType = {
  __typename?: 'TicketType';
  accessType?: Maybe<AccessType>;
  coming_soon: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Media>;
  intercom: IntercomSetting;
  min_membership_level?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  production: Production;
  start_time?: Maybe<Scalars['String']['output']>;
  start_time_formatted?: Maybe<Scalars['String']['output']>;
  ticket_bg_color: Scalars['String']['output'];
  use_dorsia_pay: Scalars['Boolean']['output'];
};

export enum TierDinnerScore {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E'
}

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type User = {
  __typename?: 'User';
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phone_formatted?: Maybe<Scalars['String']['output']>;
};

export enum VerificationMethod {
  AdminManual = 'ADMIN_MANUAL',
  ContactSync = 'CONTACT_SYNC',
  ReferralCode = 'REFERRAL_CODE'
}

/** Represents a waitlist entry for a user. */
export type Waitlist = {
  __typename?: 'Waitlist';
  created_at: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  meta?: Maybe<WaitlistMeta>;
  reason: WaitlistReason;
  status: WaitlistStatus;
  type: WaitlistType;
  updated_at: Scalars['DateTime']['output'];
};

/**
 * Union type for waitlist metadata.
 * To add new waitlist types, create a new meta type and add it to this union.
 * Example: union WaitlistMeta = MembershipWaitlistMeta | EventWaitlistMeta
 */
export type WaitlistMeta = MembershipWaitlistMeta;

export enum WaitlistReason {
  GeofenceGate = 'GeofenceGate'
}

export enum WaitlistStatus {
  Approved = 'Approved',
  Bypassed = 'Bypassed',
  Denied = 'Denied',
  LocationRequired = 'LocationRequired',
  Requested = 'Requested',
  Waiting = 'Waiting'
}

export enum WaitlistType {
  Membership = 'Membership'
}

export type AreasQueryVariables = Exact<{ [key: string]: never; }>;


export type AreasQuery = { __typename?: 'Query', areas: { __typename?: 'AreaPaginator', data: Array<{ __typename?: 'Area', id: string, name: string }> } };

export type ConciergeQueryVariables = Exact<{ [key: string]: never; }>;


export type ConciergeQuery = { __typename?: 'Query', me: { __typename?: 'Concierge', first_name: string, last_name: string, email?: string | null, phone?: string | null, teams: Array<{ __typename?: 'Team', name: string } | null> } };

export type ConfigurationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfigurationsQuery = { __typename?: 'Query', countryCodes: Array<{ __typename?: 'CountryCode', alpha2: string, name: string, code: string } | null>, dateTimeFormats: { __typename?: 'LibraryDateTimeFormats', moment: { __typename?: 'DateTimeFormat', date_long: string, date_short: string, date_dow_short: string, date_dow_long: string, date_slashes: string, date_slashes_short: string, time: string }, dateFns: { __typename?: 'DateTimeFormat', date_long: string, date_short: string, date_dow_short: string, date_dow_long: string, date_slashes: string, date_slashes_short: string, time: string } } };

export type AcceptDocumentVersionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AcceptDocumentVersionMutation = { __typename?: 'Mutation', acceptDocumentVersion: { __typename?: 'DocumentVersion', id: string } };

export type RequiredDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type RequiredDocumentsQuery = { __typename?: 'Query', requiredDocuments: Array<{ __typename?: 'DocumentVersion', id: string, version: string, markdown: string, document: { __typename?: 'Document', title: string, description?: string | null } } | null> };

export type ReservationsQueryVariables = Exact<{
  column: QueryReservationsOrderByColumn;
  order: SortOrder;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReservationsQuery = { __typename?: 'Query', reservations: { __typename?: 'ReservationPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', hasMorePages: boolean, currentPage: number, lastPage: number, perPage: number }, data: Array<{ __typename?: 'Reservation', uuid: string, table_minimum__currency?: string | null, price_per_person__currency?: string | null, party_size: number, table_type?: string | null, created_at: any, booking_link_status: BookingLinkStatus, booking_link: string, restaurant: { __typename?: 'Restaurant', name: string, address?: string | null, phone_formatted?: string | null, area?: { __typename?: 'Area', name: string } | null }, user: { __typename?: 'User', first_name?: string | null, last_name?: string | null, phone_formatted?: string | null }, reservation_at_local__formatted: { __typename?: 'DateTimeFormat', date_short: string, date_dow_short: string, time: string }, reservation_at_local__request_formatted: { __typename?: 'DateTimeFormat', date_short: string, date_dow_short: string, time: string } }> } };

export type RestaurantsByAreaQueryVariables = Exact<{
  area_id: Scalars['ID']['input'];
  party_size: Scalars['Int']['input'];
  start_date: Scalars['String']['input'];
  end_date?: InputMaybe<Scalars['String']['input']>;
}>;


export type RestaurantsByAreaQuery = { __typename?: 'Query', restaurantsByArea: Array<{ __typename?: 'Restaurant', name: string, id: string, short_description?: string | null, address?: string | null, is_new_restaurant?: boolean | null, has_frictionless?: boolean | null, transparentLogo?: { __typename?: 'Media', full_url?: string | null, thumbnail_url?: string | null, type?: string | null } | null, heroMedia?: Array<{ __typename?: 'Media', full_url?: string | null, thumbnail_url?: string | null, type?: string | null }> | null, neighborhood?: { __typename?: 'Neighborhood', id: string, name: string } | null, cuisines?: Array<{ __typename?: 'Cuisine', id: string, name: string }> | null } | null> };

export type RestaurantSearchQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type RestaurantSearchQuery = { __typename?: 'Query', restaurantSearch: { __typename?: 'RestaurantPaginator', data: Array<{ __typename?: 'Restaurant', id: string, name: string, area?: { __typename?: 'Area', id: string, name: string } | null, neighborhood?: { __typename?: 'Neighborhood', id: string, name: string } | null }> } };

export type GetRestaurantQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetRestaurantQuery = { __typename?: 'Query', restaurant?: { __typename?: 'Restaurant', id: string, name: string, address?: string | null, has_frictionless?: boolean | null, area?: { __typename?: 'Area', id: string, name: string } | null, neighborhood?: { __typename?: 'Neighborhood', id: string, name: string } | null } | null };

export type GetRestaurantAvailabilityQueryVariables = Exact<{
  restaurant_id: Scalars['ID']['input'];
  party_size: Scalars['Int']['input'];
  start_date?: InputMaybe<Scalars['String']['input']>;
  end_date?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRestaurantAvailabilityQuery = { __typename?: 'Query', getRestaurantAvailability: Array<{ __typename?: 'Availability', uid: string, price: number, price__currency: string, date?: string | null, time?: string | null, label?: string | null, datetime_label?: string | null, datetime_utc?: any | null, options: Array<{ __typename?: 'AvailabilitySeatingOption', seats: number, price: number, price__currency?: string | null, table_minimum__currency?: string | null, seating_id: number, type?: string | null, datetime_utc: any, datetime_local__formatted: { __typename?: 'DateTimeFormat', date_long: string, date_short: string, date_dow_short: string, time: string } } | null> } | null> };


export const AreasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"areas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<AreasQuery, AreasQueryVariables>;
export const ConciergeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Concierge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"teams"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ConciergeQuery, ConciergeQueryVariables>;
export const ConfigurationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Configurations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countryCodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alpha2"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateTimeFormats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"moment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date_long"}},{"kind":"Field","name":{"kind":"Name","value":"date_short"}},{"kind":"Field","name":{"kind":"Name","value":"date_dow_short"}},{"kind":"Field","name":{"kind":"Name","value":"date_dow_long"}},{"kind":"Field","name":{"kind":"Name","value":"date_slashes"}},{"kind":"Field","name":{"kind":"Name","value":"date_slashes_short"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateFns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date_long"}},{"kind":"Field","name":{"kind":"Name","value":"date_short"}},{"kind":"Field","name":{"kind":"Name","value":"date_dow_short"}},{"kind":"Field","name":{"kind":"Name","value":"date_dow_long"}},{"kind":"Field","name":{"kind":"Name","value":"date_slashes"}},{"kind":"Field","name":{"kind":"Name","value":"date_slashes_short"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]}}]} as unknown as DocumentNode<ConfigurationsQuery, ConfigurationsQueryVariables>;
export const AcceptDocumentVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptDocumentVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptDocumentVersion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AcceptDocumentVersionMutation, AcceptDocumentVersionMutationVariables>;
export const RequiredDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RequiredDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requiredDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"markdown"}}]}}]}}]} as unknown as DocumentNode<RequiredDocumentsQuery, RequiredDocumentsQueryVariables>;
export const ReservationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Reservations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"column"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryReservationsOrderByColumn"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SortOrder"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reservations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"column"},"value":{"kind":"Variable","name":{"kind":"Name","value":"column"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order"}}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"byStatuses"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasMorePages"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"lastPage"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"table_minimum__currency"}},{"kind":"Field","name":{"kind":"Name","value":"price_per_person__currency"}},{"kind":"Field","name":{"kind":"Name","value":"party_size"}},{"kind":"Field","name":{"kind":"Name","value":"table_type"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"phone_formatted"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"first_name"}},{"kind":"Field","name":{"kind":"Name","value":"last_name"}},{"kind":"Field","name":{"kind":"Name","value":"phone_formatted"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reservation_at_local__formatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date_short"}},{"kind":"Field","name":{"kind":"Name","value":"date_dow_short"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reservation_at_local__request_formatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date_short"}},{"kind":"Field","name":{"kind":"Name","value":"date_dow_short"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"Field","name":{"kind":"Name","value":"booking_link_status"}},{"kind":"Field","name":{"kind":"Name","value":"booking_link"}}]}}]}}]}}]} as unknown as DocumentNode<ReservationsQuery, ReservationsQueryVariables>;
export const RestaurantsByAreaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RestaurantsByArea"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"area_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"party_size"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restaurantsByArea"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"area_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"area_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"party_size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"party_size"}}},{"kind":"Argument","name":{"kind":"Name","value":"start_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"Argument","name":{"kind":"Name","value":"end_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"short_description"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"is_new_restaurant"}},{"kind":"Field","name":{"kind":"Name","value":"has_frictionless"}},{"kind":"Field","name":{"kind":"Name","value":"transparentLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"heroMedia"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"full_url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail_url"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"neighborhood"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cuisines"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<RestaurantsByAreaQuery, RestaurantsByAreaQueryVariables>;
export const RestaurantSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RestaurantSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restaurantSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"neighborhood"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RestaurantSearchQuery, RestaurantSearchQueryVariables>;
export const GetRestaurantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRestaurant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restaurant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"has_frictionless"}},{"kind":"Field","name":{"kind":"Name","value":"area"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"neighborhood"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetRestaurantQuery, GetRestaurantQueryVariables>;
export const GetRestaurantAvailabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRestaurantAvailability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"restaurant_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"party_size"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRestaurantAvailability"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"restaurant_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"restaurant_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"party_size"},"value":{"kind":"Variable","name":{"kind":"Name","value":"party_size"}}},{"kind":"Argument","name":{"kind":"Name","value":"start_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"start_date"}}},{"kind":"Argument","name":{"kind":"Name","value":"end_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"price__currency"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"datetime_label"}},{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"seats"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"price__currency"}},{"kind":"Field","name":{"kind":"Name","value":"table_minimum__currency"}},{"kind":"Field","name":{"kind":"Name","value":"seating_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"datetime_utc"}},{"kind":"Field","name":{"kind":"Name","value":"datetime_local__formatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date_long"}},{"kind":"Field","name":{"kind":"Name","value":"date_short"}},{"kind":"Field","name":{"kind":"Name","value":"date_dow_short"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRestaurantAvailabilityQuery, GetRestaurantAvailabilityQueryVariables>;